
import { useLocation, useParams } from "react-router-dom";
import { Users, Package, BookOpen, Calendar, DollarSign, Bell, Settings, LayoutDashboard, Dumbbell } from "lucide-react";
import SidebarLink from "./SidebarLink";

interface MenuItem {
  to: string;
  icon: React.ElementType;
  label: string;
  badge?: React.ReactNode;
}

interface SidebarMenuProps {
  isAdmin: boolean | null;
  clientId: string | null;
  unreadCount: number;
  fetchUnreadCount: () => Promise<void>;
}

const SidebarMenu = ({
  isAdmin,
  clientId,
  unreadCount,
  fetchUnreadCount
}: SidebarMenuProps) => {
  const location = useLocation();
  const params = useParams();
  const userSlug = params.userSlug;
  
  // Funzione per verificare se un percorso è attualmente attivo
  const isPathActive = (path: string) => {
    if (userSlug) {
      // Per i percorsi personalizzati
      const customPath = path.replace('/admin/', `/${userSlug}/`);
      return location.pathname === customPath || 
             (customPath.includes('/clients') && location.pathname.includes(`/${userSlug}/clients`));
    } else {
      // Per i percorsi admin standard
      return location.pathname === path || 
             (path.includes('/clients') && location.pathname.includes('/admin/clients'));
    }
  };

  const adminItems: MenuItem[] = [{
    to: "/admin/dashboard",
    icon: LayoutDashboard,
    label: "Dashboard"
  }, {
    to: "/admin/calendar",
    icon: Calendar,
    label: "Calendario"
  }, {
    to: "/admin/clients",
    icon: Users,
    label: "Clienti"
  }, {
    to: "/admin/packages",
    icon: Package,
    label: "Pacchetti"
  }, {
    to: "/admin/courses",
    icon: BookOpen,
    label: "Corsi"
  }, {
    to: "/admin/workouts",
    icon: Dumbbell,
    label: "Allenamenti"
  }, {
    to: "/admin/payments",
    icon: DollarSign,
    label: "Pagamenti"
  }, {
    to: "/admin/notifications",
    icon: Bell,
    label: "Notifiche",
    badge: unreadCount > 0 ? <div className="ml-auto">
          <div className="h-2 w-2 rounded-full bg-red-500 animate-pulse"></div>
        </div> : null
  }, {
    to: "/admin/home-options",
    icon: Settings,
    label: "Opzioni Homepage"
  }];
  
  const userItems: MenuItem[] = [{
    to: clientId ? `/admin/clients/${clientId}` : "/admin/clients",
    icon: Users,
    label: "I miei Dati"
  }, {
    to: "/admin/calendar",
    icon: Calendar,
    label: "Calendario"
  }, {
    to: "/admin/client-notifications",
    icon: Bell,
    label: "Notifiche",
    badge: unreadCount > 0 ? <div className="ml-auto">
          <div className="h-2 w-2 rounded-full bg-red-500 animate-pulse"></div>
        </div> : null
  }];
  
  const items = isAdmin ? adminItems : userItems;
  
  return <nav className="space-y-6">
      <div className="space-y-1 py-4">
        <p className="px-4 text-xs font-medium text-gray-500 uppercase tracking-wider mb-2">
          Menu
        </p>
        {items.map(item => 
          <SidebarLink 
            key={item.to} 
            to={item.to} 
            icon={item.icon} 
            label={item.label} 
            badge={item.badge} 
            isCurrent={isPathActive(item.to)} 
            onClick={item.to.includes('notifications') ? fetchUnreadCount : undefined} 
          />
        )}
      </div>
    </nav>;
};

export default SidebarMenu;
